import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { SearchPatientTotemRequest } from '../../requests/orchestrator-totem/search-patient-totem.request';
import { GetPatientByCpfResponse } from '../../responses/medical-record/get-patient-by-cpf.response';
import { from, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientGetPatientByCpfTotemService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getClientPatientByCPF(idHealthUnit: number, request: SearchPatientTotemRequest, imageResultRef: string | null): Observable<GetPatientByCpfResponse> {
    let uri = `api/SearchPatient/idHealthUnit/${idHealthUnit}`

    if (!imageResultRef) {
      // No image: send only body in FormData
      const formData = new FormData();
      if (request.cpf)
        formData.append('cpf', request.cpf);
      if (request.cns)
        formData.append('cns', request.cns);

      return this.httpClient.post<GetPatientByCpfResponse>(
        environment.urlApiOrchestratorTotem + uri,
        formData,
        this.addHeaderFormHashTotem()
      );
    }

    // Image present: fetch blob and send FormData
    return from(fetch(imageResultRef).then(res => res.blob())).pipe(
      switchMap((blob: Blob) => {
        const formData = new FormData();
        formData.append('imageFile', blob, 'face.jpg');

        return this.httpClient.post<GetPatientByCpfResponse>(
          environment.urlApiOrchestratorTotem + uri,
          formData,
          this.addHeaderFormHashTotem()
        );
      })
    );
  }

  public getClientPatientScheduleByCPF(idHealthUnit: number, timeZoneValue: number, request: SearchPatientTotemRequest): Observable<GetPatientByCpfResponse> {
    let uri = `api/SearchPatientSchedule/idHealthUnit/${idHealthUnit}/timeZoneValue/${timeZoneValue}`
    return this.httpClient.post<GetPatientByCpfResponse>(environment.urlApiOrchestratorTotem + uri, request, this.addHeaderHashTotem())
      .pipe(
        catchError(this.handleError)
      )
  }
}